$('.mega-menu__item').mouseenter(function() {
  var className = $(this).attr('data-class-name');
  $('.header-background').addClass(`list_menu_active ${className}`);
  $('.header-background').attr("data-class-name", className)
}).mouseleave(function () {
  var className = $(this).attr('data-class-name');
  $('.header-background').removeClass(`list_menu_active ${className}`);
  $('.header-background').removeAttr("data-class-name", className)
});



$(document).ready(function(){
  $('.header__menu-item').mouseenter(function(){
    var className = $(this).data('class-name');
    $(`.menu_image_child.${className}`).addClass(`is-active`);
  }).mouseleave(function () {
    var $el = $(this);
    var className = $el.data('class-name');
    setTimeout(function() {
      $(`.menu_image_child.${className}`).removeClass(`is-active`);
    }, 150);
  });
});
      

function setCssVariable() {
  let elements = [
    "starter-kits",
    "accessories",
    "supplements",
    "samples",
    "subscribe-save-10",
    "find-your-supplements",
    "join-our-mission",
    "declutter-your-countertop",
    "the-plastic-problem", 
    "our-story",
    
  ];
  elements.forEach(function(element, index) {
    const el = document.querySelector(`.list-menu-child.${element}`);
    if (el) {
      window.requestAnimationFrame(function() {
        document.documentElement.style.setProperty(`--element${index+1}-height`, el.clientHeight + 'px');
      });
    }
  });
}


document.addEventListener("DOMContentLoaded", function() {
  setTimeout(setCssVariable, 500); // delay the execution of setCssVariable() by 2 seconds
});
